import { Component, OnInit, inject } from '@angular/core';
import { PagesService } from '../pages.service';
import { MenuItem } from '../producers/interfaces';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-about-us',
    imports: [RouterOutlet],
    templateUrl: './about-us.component.html',
    styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {
  pagesService = inject(PagesService);

  ngOnInit(): void {
    this.setUpMenu();
  }

  private setUpMenu() {
    const sideMenu: MenuItem[] = [
      {
        link: 'about-us/main',
        title: 'About Us',
        active: true,
      },
      {
        link: 'about-us/support',
        title: 'Building a Local Food System',
        active: false
      },
      {
        link: 'about-us/donations',
        title: 'Increasing Access to Local Food',
        active: false
      },
      {
        link: 'about-us/packaging',
        title: 'Moving Towards Zero Waste',
        active: false
      },
    ];
    this.pagesService.setSideMenu(sideMenu);
  }
}
